/**
 * Derives React Router's `basename` from CRA's `PUBLIC_URL` so in-app navigation
 * stays under subpath deploys (e.g. PR previews at `/preview/<branch-slug>/`).
 */
export function getRouterBasenameFromPublicUrl(publicUrl: string | undefined): string {
  const raw = (publicUrl ?? '').trim();
  if (!raw) {
    return '';
  }
  try {
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      const path = new URL(raw).pathname;
      return path.replace(/\/$/, '') || '';
    }
    const path = raw.startsWith('/') ? raw : `/${raw}`;
    return path.replace(/\/$/, '') || '';
  } catch {
    return '';
  }
}
